import { ImageType } from "model"

export const transformImage = (image: any, alt: string): ImageType => {
  return image
    ? {
        id: image.databaseId,
        alt,
        src: image.sourceUrl,
        srcSet: image.srcSet,
      }
    : undefined
}
